import React, {Component} from 'react';
import {render} from 'react-dom';
import $ from 'jquery';

import data from './data';

import NewsList from './components/_newsList';
import ArticleList from './components/_articleList';

function attachCustomAttributes(domNode) {
  if (domNode) {
    domNode.setAttribute('playsinline', true);
    domNode.setAttribute('autoplay', true);
    domNode.setAttribute('muted', true);
  }
}

export default class Index extends Component {

	constructor(props) {

		super(props);
		this.state = {
		};
    this.pushMessage = this.pushMessage.bind(this);
	}

	componentWillMount() {

    let scroll = 0;
    $("a[href^='#']").on('click', function () {
      var speed = 500,
        href = $(this).attr("href"),
        target = $(href == "#" || href == "" ? 'html' : href),
        position = target.offset().top;
      $("html, body").animate({scrollTop: position - 40}, speed, "swing");
      return false;
    });
		
	}

	componentWillReceiveProps() {

	}

  pushMessage(){
    this.props.onEventCallBack();
  }

	componentDidMount() {

    $("html, body").animate({scrollTop: 0}, 1);

    let video = $('#mv').get(0);
    let play = video.play();
    if(play instanceof Promise) {
      play.catch(error => {
        console.error('自動再生できません');
      });
    }

	}

	render() {
		return (
				<div className="wrap index" id="top">
          <section className="heroimage">
            <div className="splash">
              <video id="mv" src="/images/gids.mp4" ref={attachCustomAttributes} autoPlay={true} muted={true} loop={true} />
            </div>
            <div className="signs">
              <div><img src="/images/icon_concept01.svg"/></div>
              <div><img src="/images/icon_concept02.svg"/></div>
              <div><img src="/images/icon_concept03.svg"/></div>
              <div><img src="/images/icon_concept04.svg"/></div>
            </div>
          </section>
          <NewsList title="NEWS" feed={this.props.feed} />
          <ArticleList
            title="TOPICS"
            article={this.props.article}
            tags={this.props.tags}
            page={this.props.page}
            onEventCallBack={this.pushMessage}
          />
					<div className="pagetop"><a href="#top"><img src="/images/pagetop.png" alt="pagetop"/></a></div>
				</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/js/index.js